import { Component, OnInit } from '@angular/core';
import { PaymentService } from '@core/payments/services/payment.service';

@Component({
    selector: 'app-webstore-confirmation',
    templateUrl: './webstore-confirmation.component.html',
    styleUrls: ['./webstore-confirmation.component.css'],
    standalone: false
})
export class WebstoreConfirmationComponent {

  totalAmount         : string = '0';
  purchaseDescription : string = '';
  date                : string = '';
  status              : string = '';
  transaction         : string = '';
  currency            : string = '';

  constructor(private _paymentService: PaymentService,){}

  ngOnInit(){
    console.log(this._paymentService.requestpayment.result);
    this.currency = localStorage.getItem('currencySymbol') as string;
    if(this._paymentService.requestpayment.result){
      this.totalAmount = this._paymentService.requestpayment.result.totalAmount;
      this.purchaseDescription = this._paymentService.requestpayment.result.purchaseDescription;
      this.date = this._paymentService.requestpayment.result.dateFormat;
      this.transaction = this._paymentService.requestpayment.result.cus;
    }
  }
}
